import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

ScrollTrigger.matchMedia({
	"(min-width: 768px)": function () {

		$(window).on("load", function () {

			ScrollTrigger.create({
				trigger: '#trailer01',
				start: 'top 45%',
				end: 'bottom 45%',
				// markers: true,
				toggleClass: {
					targets: ".js-navItem01",
					className: "is-on"
				},
				// once: true,
			});
			ScrollTrigger.create({
				trigger: '#trailer02',
				start: 'top 45%',
				end: 'bottom 45%',
				// markers: true,
				toggleClass: {
					targets: ".js-navItem02",
					className: "is-on"
				},
				// once: true,
			});
			ScrollTrigger.create({
				trigger: '#trailer03',
				start: 'top 45%',
				end: 'bottom 45%',
				// markers: true,
				toggleClass: {
					targets: ".js-navItem03",
					className: "is-on"
				},
				// once: true,
			});
			ScrollTrigger.create({
				trigger: '#trailer04',
				start: 'top 45%',
				end: 'bottom 45%',
				// markers: true,
				toggleClass: {
					targets: ".js-navItem04",
					className: "is-on"
				},
				// once: true,
			});
			ScrollTrigger.create({
				trigger: '#trailer05',
				start: 'top 45%',
				end: 'bottom 45%',
				// markers: true,
				toggleClass: {
					targets: ".js-navItem05",
					className: "is-on"
				},
				// once: true,
			});
			ScrollTrigger.create({
				trigger: '#trailer06',
				start: 'top 45%',
				end: 'bottom 45%',
				// markers: true,
				toggleClass: {
					targets: ".js-navItem06",
					className: "is-on"
				},
				// once: true,
			});
			ScrollTrigger.create({
				trigger: '#trailer07',
				start: 'top 45%',
				end: 'bottom 45%',
				// markers: true,
				toggleClass: {
					targets: ".js-navItem07",
					className: "is-on"
				},
				// once: true,
			});
		});
	},
});

$(window).on("load", function () {

	ScrollTrigger.create({
		trigger: '.js-entryTrigger',
		start: 'top 100%',
		end: 'bottom 100%',
		// markers: true,
		toggleClass: {
			targets: ".js-entryFixed",
			className: "on"
		},
		// once: true,
	});

});
